import FileSecurityLevelCard from './FileSecurityLevelCard.component';

export default FileSecurityLevelCard;
